import { useEffect, useState } from 'react'
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  setDoc
} from 'firebase/firestore'
import { db } from '@/firebase'

interface MailTemplate {
  id: string
  name: string
  subject: string
  body: string
  createdAt: string
  updatedAt: string
}

const useTemplates = () => {
  const [templates, setTemplates] = useState<MailTemplate[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const q = query(
      collection(db, 'platformmailtemplates'),
      orderBy('updatedAt', 'desc')
    )
    const unsub = onSnapshot(
      q,
      (snap) => {
        setTemplates(
          snap.docs.map((d) => {
            const data = d.data()
            return {
              id: d.id,
              name: data.name || '',
              subject: data.subject || '',
              body: data.body || '',
              createdAt: data.createdAt || '',
              updatedAt: data.updatedAt || ''
            }
          })
        )
        setLoading(false)
      },
      (err) => {
        console.error('Failed to fetch templates', err)
        setLoading(false)
      }
    )
    return () => unsub()
  }, [])

  return { templates, loading }
}

const saveTemplate = async (
  template: Omit<MailTemplate, 'id' | 'createdAt' | 'updatedAt'> & {
    id?: string
  }
) => {
  const now = new Date().toISOString()
  const id = template.id || `tpl-${Date.now()}`
  const ref = doc(collection(db, 'platformmailtemplates'), id)
  await setDoc(
    ref,
    {
      id,
      name: template.name,
      subject: template.subject,
      body: template.body,
      createdAt: now,
      updatedAt: now
    },
    { merge: true }
  )
  return id
}

const deleteTemplate = async (id: string) => {
  await deleteDoc(doc(collection(db, 'platformmailtemplates'), id))
}

export { useTemplates, saveTemplate, deleteTemplate }
export type { MailTemplate }
